<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted } from "vue";

const props = withDefaults(
  defineProps<{ open?: boolean; title?: string; placement?: "sheet" | "center" }>(),
  { open: true, placement: "sheet" },
);
const emit = defineEmits<{ close: [] }>();

const centred = computed(() => props.placement === "center");

/** Escape closes; a sheet you cannot dismiss with the keyboard is a trap. */
function onKey(event: KeyboardEvent) {
  if (event.key === "Escape" && props.open) emit("close");
}
onMounted(() => document.addEventListener("keydown", onKey));
onBeforeUnmount(() => document.removeEventListener("keydown", onKey));
</script>
<template>
  <div
    v-if="open"
    class="cw-scrim"
    :class="{ 'cw-scrim--center': centred }"
    @click.self="emit('close')"
  >
    <div
      class="cw-dialog"
      :class="{ 'cw-dialog--center': centred }"
      role="dialog"
      aria-modal="true"
    >
      <span
        v-if="!centred"
        class="cw-dialog__grab"
      />
      <h2
        v-if="title"
        class="cw-dialog__title"
      >
        {{ title }}
      </h2>
      <div class="cw-dialog__body">
        <slot />
      </div>
      <div
        v-if="$slots.footer"
        class="cw-dialog__foot"
      >
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>
